<template>
  <div class="pilih-jadwal">
    <SOSlotBase :container-name="`pilih-jadwal`" :loading="isLoading">
      <template v-slot:title-bar>
        <SOTitleBar :page-title="'Pilih Jadwal'" :type="'back'" @back="back" />
      </template>

      <template v-slot:content>
        <div class="bg p-x-20 p-y-12 d-flex">
          <div class="d-block">
            <div class="f-semi f-14">
              Pilih tanggal yang tertera dibawah untuk menentukan jadwal
              training
            </div>
          </div>
        </div>
        <template>
          <div class="calendar">
            <sm-date-picker
              is-expanded
              :disabled-dates="disabledDates"
              :min-date="new Date()"
              :select-attribute="selectAttribute"
              @dayclick="onDayClick"
              :value="value"
            />
          </div>
          <hr />
          <div class="jadwal-info">
            <div class="p-x-20">
              <div class="f-14 f-regular f-c-primary p-y-16">
                <label class="m-d-0"> Jadwal Training </label>
              </div>
              <div class="f-18 f-regular">
                <p>Belum dipilih</p>
              </div>
            </div>
          </div>
        </template>
        <div class="p-x-20">
          <button
            class="btn btn-primary btn-long btnlnjt"
            :disabled="isButtonDisabled"
            :class="{ 'btn-disabled': isButtonDisabled }"
            @click="handleButtonClick"
          >
            Lanjutkan
          </button>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth();
export default {
  name: "PilihJadwal",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOButton,
  },
  data() {
    return {
      isLoading: false,
      value: null,
      date: new Date(),
      selectAttribute: {
        highlight: "green",
      },
      disabledDates: [{ weekdays: [1, 7] }],

      isButtonDisabled: true,
      namaProgram: "",
      jadwalTraining: "",
      namaOwner: "",
    };
  },

  watch: {
    namaProgram(newVal) {
      this.updateButtonStatus();
    },
    jadwalTraining(newVal) {
      this.updateButtonStatus();
    },
    namaOwner(newVal) {
      this.updateButtonStatus();
    },
  },

  methods: {
    updateButtonStatus() {
      if (this.namaProgram && this.jadwalTraining && this.namaOwner) {
        this.isButtonDisabled = false;
      } else {
        this.isButtonDisabled = true;
      }
    },

    handleButtonClick() {
      if (!this.isButtonDisabled) {
      }
    },
    back() {
      this.$router.go(-1);
    },
    onDayClick(date) {
      const routeName = "pilihProgramFODone";
      this.$router.push({ name: routeName });
    },
  },
};
</script>

<style scoped>
.belajar-bersama-smartlink .separator {
  width: unset;
}
.d-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.text-container {
  display: flex;
}

.text-container .epayment-container {
  width: 121px;
}
.text-container .reminder-container {
  width: 71px;
}

.bg {
  background-color: #f2f5f7;
  color: #6f7287;
  padding: 20px;
  display: flex;
  padding: 12px 20px;
  align-items: center;
  flex: 1 0 0;
}

.custom-margin-top {
  margin-top: 10px;
}

.m-r-12 {
  margin-right: 12px;
}
.btnlnjt {
  margin-top: 4rem;
  background-color: #206cff;
  color: white;
}
.btn-disabled {
  background-color: #ccc;
  color: #f6f6f6;
}

.title {
  color: #6f7287;
  text-align: center;
  font-family: Overpass;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.28px;
}

.details {
  color: var(--text-primary, #212121);
  text-align: center;
  font-family: Overpass;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.32px;
}

.calendar {
  display: flex;
  padding: 16px 20px;
  flex-direction: column;
  align-items: start;
}

.jadwal-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
